<template>
  <NuxtLink
    :to="
      localePath({ name: 'categories-slug', params: { slug: category.slug } })
    "
    class="category-item"
  >
    <div class="category-item-cover">
      <BaseImageExternal
        v-if="category.fileUrl"
        class="category-cover"
        :src="category.fileUrl"
        :alt="$t('category.cover-alt', [category.name])"
      />
    </div>
    <div class="category-item-info">
      <BaseText class="card-title">{{ category.name }}</BaseText>
    </div>
  </NuxtLink>
</template>

<script setup lang="ts">
import { type CategoryFragment } from "~/graphql/generated";

defineProps<{
  category: CategoryFragment;
}>();

const localePath = useLocalePath();
</script>

<style lang="scss" scoped>
.category-item {
  background-color: $light-100;
  border: 1px solid $light-80;
  overflow: hidden;
  border-radius: $border-radius;
  display: flex;
  flex-direction: column;
  justify-content: space-between;

  .category-item-cover {
    flex: 1;
    padding: 1rem;
    display: flex;
    align-items: center;
    justify-content: center;
  }

  .category-cover {
    width: 3rem;
    height: 3rem;
    aspect-ratio: 1/1;
  }

  .category-item-info {
    margin-top: auto;
    padding: 0.5rem;
  }
}
</style>
